import useIsMobile from "@/core/hooks/useIsMobile";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";

export const EmblaDraggableSlider = ({ listCard }: { listCard: any }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const isMobile = useIsMobile(768);
    const isTablet = useIsMobile(1024);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleMouseDown = (e: MouseEvent) => {
            if (!isTablet || isMobile) return;
            setIsDragging(true);
            setStartX(e.pageX - container.offsetLeft);
            setScrollLeft(container.scrollLeft);
        };

        const handleMouseMove = (e: MouseEvent) => {
            if (!isDragging || !container) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX) * 1.5; // pull speed
            container.scrollLeft = scrollLeft - walk;
        };

        const handleMouseUp = () => setIsDragging(false);
        const handleMouseLeave = () => setIsDragging(false);

        container.addEventListener("mousedown", handleMouseDown);
        container.addEventListener("mousemove", handleMouseMove);
        container.addEventListener("mouseup", handleMouseUp);
        container.addEventListener("mouseleave", handleMouseLeave);

        return () => {
            container.removeEventListener("mousedown", handleMouseDown);
            container.removeEventListener("mousemove", handleMouseMove);
            container.removeEventListener("mouseup", handleMouseUp);
            container.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, [isDragging, startX, scrollLeft, isMobile, isTablet]);

    return (
        <div
            ref={containerRef}
            className={
                clsx("overflow-x-auto scroll-smooth snap-x snap-mandatory touch-pan-x touch-pan-y pb-4 scroll-custom",
                    isTablet ? 'select-none' : ''
                )
            }
        >
            <div className="flex w-full">
                {listCard?.map((card: any, index: number) => (
                    <div
                        key={index}
                        className="pr-4 snap-start hover:cursor-pointer transition-all duration-500"
                    >
                        {card}
                    </div>
                ))}
            </div>
        </div>

    );
};

